// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"db2ab631","838":"4fdb61bb"}[chunkId] + ".js";
};